module.exports = __webpack_public_path__ + "media/images/home/icon-arrow-right-5f23c4c1877daeab585dd885e6b12968.svg";